import MultiSelect from './MultiSelect';

export * from './MultiSelectProps';
export default MultiSelect;
